import { Tabs, Table } from "antd";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { showloader, transactionClicked } from "../store/gloabalState";
import { Link } from "react-router-dom";
import { DateConvert } from "../utils/dateConverter";
import { getFilteredTransactionAll, getTransactions } from "../services/httpCalls";
import { getcookieFunc } from "../utils/useCookies";


const OngoingTransactions = () => {

    // local states
    const [ongoingTransactions, setOngoingTransactions] = useState([]);
    const [totalCountOG, setTotalCountOG] = useState(0);

    // global states

    // states

    // values

    // setter/updater
    const setShowLoader = useSetRecoilState(showloader);
    const setTransactionId = useSetRecoilState(transactionClicked)

    // constants/binders
    const accessToken = getcookieFunc();

    const  fetchTransactions = async (pageNumber) => {
        setShowLoader(true);
        const filters = `status=INITIATED,CB15,CA15,DOCUMENT_PREPARED,TRANSACTION_INITIATED,FUND_REQUESTED,APPROVED&viewUnassigned=false&`
        await getFilteredTransactionAll(filters,pageNumber)
          .then((res) => {
            setTotalCountOG(res?.totalCount);
            setOngoingTransactions(res?.transactionDetailResponseDtoList);
            setShowLoader(false);
          })
          .catch((err) => {
            console.log("err", err);
            setShowLoader(false);
          });
      }

    useEffect(() => {
        fetchTransactions(0)
    },[])

    const colsOngoing = [
        {
          title: "TransactionId",
          dataIndex: "transactionId",
          key: "transactionId",
          align: "center",
          render: (val, record) => {
             if(record?.productType === "INWARD") {
                return(
                  <Link
                  to={"/transactiondetail/inward/" + val}
                  style={{
                    color: "#000",
                  }}
                  onClick={() => {
                    setTransactionId(record?.transactionId);
                  }}
                >
                  {record?.transactionId}
                </Link>
                )
            } else {
                return(
                  <Link
              to={"/transactiondetail/" + val}
              style={{
                color: "#000",
              }}
              onClick={() => {
                setTransactionId(record?.transactionId);
              }}
            >
              {record?.transactionId}
            </Link>
                )
            }
          }
        },
        {
          title: "Customer Name",
          dataIndex: "customerName",
          key: "customerName",
          align: "center",
          filterSearch: true,
          render: (val) => (val ? val : "-"),
        },
        {
          title: "Vendor Name",
          dataIndex: "vendorName",
          key: "vendorName",
          align: "center",
          filterSearch: true,
          render: (val) => (val ? val : "-"),
        },
        {
          title: "Initiated Date",
          dataIndex: "initiationDate",
          key: "initiationDate",
          align: "center",
          render: (val, record) =>
            DateConvert(record?.initiationDate)
              ? DateConvert(record?.initiationDate)
              : "-",
        },
    
        {
          title: "Initiated By",
          dataIndex: "addedBy",
          key: "addedBy",
          align: "center",
          render: (val) => (val ? val : "-"),
        },
        {
          title: "Stage",
          dataIndex: "stage",
          key: "stage",
          align: "center",
          render: (val) => (val ? val : "-"),
        },
        {
          title: "Assigned To",
          dataIndex: "assignedOpsMember",
          key: "assignedOpsMember",
          align: "center",
          render: (val) => (val ? val : "-"),
        },
        {
          title: 'Bank Name',
          dataIndex: 'bankName',
          key: 'bankName',
          align: 'center',
          render: (val) => (val ? val : '-')
        },
        {
          title:"Transaction Type",
          dataIndex: 'transactionType',
          key: 'transactionType',
          render: (val) => val ? val : '-',
          align:'center'
        },
        {
          title: 'Product Type',
          dataIndex: 'productType',
          key: 'productType',
          render: (val) => val ? val : '-',
          align:"center"
        }
      ];

      const items = [
        {
            key: "1",
            label: "",
            children: ongoingTransactions &&
                 <Table
                  columns={colsOngoing}
                  dataSource={ongoingTransactions}
                  pagination={{
                    pageSize: 10,
                    total: totalCountOG,
                    showSizeChanger: false,
                    position: ["bottomCenter"],
                   }}
                  rowKey={(record) => record?.transactionId}
                  onChange={(page) => {
                  fetchTransactions(page.current - 1);
                  }}
                  className="styledAntd"
                />
        }
      ]

      const onChangeHandler = () => {}

      return(
        <Tabs
            defaultActiveKey="1"
            items={items}
            onChange={onChangeHandler}
        />
      )

}

export default OngoingTransactions;